export default function downloadBlob(blob: any, filename: string, options?: BlobPropertyBag) {
    // See: https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/

    let blobObj = new Blob([blob], options);

    // Internet Explorer & Edge require the use of msSaveOrOpenBlob
    const nav = (window.navigator as any)
    if (nav && nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blobObj, filename);
        return;
    }

    // Create a link object and click it
    // Firefox requires us to append the element to the body, and then remove & revoke it after a timeout
    const data = URL.createObjectURL(blobObj);

    let link = document.createElement("a");
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(data);
    }, 100);
}


// WEBPACK FOOTER //
// ./ClientApp/utils/downloadBlob.ts